import { render, staticRenderFns } from "./URLForm.vue?vue&type=template&id=040cce5d&scoped=true&"
import script from "./URLForm.vue?vue&type=script&lang=js&"
export * from "./URLForm.vue?vue&type=script&lang=js&"
import style0 from "./URLForm.vue?vue&type=style&index=0&id=040cce5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040cce5d",
  null
  
)

export default component.exports